import React from "react";
import {
  NavbarSticky,
  Typography,
  Chip,
  ProgressiveButton,
  ButtonDS,
} from "get-life-storybook-ts";
import { ChipI } from "get-life-storybook-ts/lib/atoms/Chip/Chip";
import { numberFormatPayment } from "../../../utils/Utils";
import { NewProductI } from "../../../api/request/Lead/Interfaces/ProductInterface.response";

interface UpsellStickyBarProps {
  product: NewProductI;
  translate: (key: string) => string;
  isABtesting: boolean;
  chipsData: ChipI[];
  selectPlan: () => void;
  correctPrice: (property: keyof NewProductI) => any;
  getDiscountedMonthlyPriceWithCurrency: () => string;
  loading?: boolean;
}

const UpsellStickyBar: React.FC<UpsellStickyBarProps> = ({
  product,
  translate,
  isABtesting,
  chipsData,
  selectPlan,
  correctPrice,
  getDiscountedMonthlyPriceWithCurrency,
  loading = false,
}) => {
  const handleSelectPlan = () => {
    if (loading) return;
    selectPlan();
  };
  return (
    <NavbarSticky
      position="bottom"
      content={
        <div className="payment-newUpsellContainer__buyCard--content">
          <div className="flex flex-col">
            {!!product.promotion &&
              product.regularPrice !== product.priceToPay && (
                <Typography
                  variant="SpanMedium"
                  weight="400"
                  text={`${numberFormatPayment(
                    correctPrice("regularPrice") ?? 0
                  )}€`}
                  className="payment-newUpsellContainer__buyCard--discounted"
                />
              )}
            <div className="payment-newUpsellContainer__buyCard--price">
              <Typography
                variant="H2"
                text={
                  loading ? "…" : getDiscountedMonthlyPriceWithCurrency()
                }
              />
              <Typography
                variant="Span"
                weight="400"
                text={`/${translate("upsell.BuyCard.month")}`}
              />
            </div>
          </div>
          <div className="payment-newUpsellContainer__chips">
            {chipsData.map((d, idx) => (
              <Chip
                text={d.text}
                type={d.type}
                icon="CheckedIcon"
                key={`${d.text}_${idx}`}
              />
            ))}
          </div>
        </div>
      }
      actions={
        isABtesting ? (
          <div className="payment-newUpsellContainer__buyCard--actions">
            <ProgressiveButton
              onClick={() => handleSelectPlan()}
              text="Protégete"
            />
          </div>
        ) : (
          <ButtonDS
            label={translate("aggregator.personalInformation.btnContract")}
            onClick={() => handleSelectPlan()}
            className="w-full"
            disabled={loading}
          />
        )
      }
    />
  );
};

export default UpsellStickyBar;
